import cui from './cui/cui.js';
import KCSModal from './Modal/KCSModal.js';
import PrivacyPolicyConsentModal from './Modal/PrivacyPolicyConsentModal';
import ConfirmOtp from './Modal/ConfirmOtp.js';
import InputText from './InputText/InputText.js';
import InputRadio from './InputRadio/InputRadio.js';
import InputCheckbox from './InputCheckbox/InputCheckbox.js';
import InputDropdown from './InputDropdown/InputDropdown.js';
import DropdownAntd from './InputDropdown/DropdownAntd.js';
import InputSearch from './InputSearch/InputSearch.js';
import CuiTextArea from './CuiTextArea/CuiTextArea.js';
import TextAreaAntd from './CuiTextArea/TextAreaAntd.js';
import CuiAutoText from './CuiAutoText/CuiAutoText.js';
import ProgressTurn from './ProgressTurn/ProgressTurn.js';
import ScrollTop from './ScrollTop/ScrollTop.js';
import Carousel from './Carousel/Carousel.js';
import { Notification } from './Notification/Notification.js';
import DataCard from './DataCard/DataCard.js';
import Slide from './Slide/Slide.js';
import Button from './Button/Button.js';
import I18n from './i18n/I18n.js';
import I18nService from './i18n/I18nService.js';
import SlideWrapper from './SlideWrapper/SlideWrapper.js';
import FormOrder from './FormOrder/FormOrder.js';
import MapPopup from './Map/MapPopup.js';
import MemberDetail from './MemberDetail/MemberDetail.js';
import AddMemberPopup from './MemberPopup/AddMemberPopup.js';
import CallLimitPopup from './MemberPopup/CallLimitPopup.js';
import Slider from './Slider/Slider.js';
import Loading from './Loading/Loading.js';
import BoxNews from './BoxNews/BoxNews.js';
import InputAntd from './InputText/InputAntd.js';
import OutsideClick from './OutsideClick/OutsideClick.js';


export {
  cui,
  KCSModal,
  PrivacyPolicyConsentModal,
  ConfirmOtp,
  InputText,
  InputRadio,
  InputCheckbox,
  InputDropdown,
  InputSearch,
  CuiTextArea,
  CuiAutoText,
  ProgressTurn,
  ScrollTop,
  Carousel,
  Notification,
  DataCard,
  Slide,
  Button,
  I18n,
  I18nService,
  SlideWrapper,
  FormOrder,
  MapPopup,
  MemberDetail,
  AddMemberPopup,
  CallLimitPopup,
  Slider,
  Loading,
  BoxNews,
  InputAntd,
  DropdownAntd,
  TextAreaAntd,
  OutsideClick,
};
